export default {

    // requires reference to table example:
    // <table ref="export">

    methods: {

        exportTableToCSV() {

            let csv = ['sep=,'];
            let rows = this.$refs.export.querySelectorAll('tr');

            for (let i = 0; i < rows.length; i++) {
                let row = [], cols = rows[i].querySelectorAll('td, th');

                for (let j = 0; j < cols.length; j++) {
                    row.push('"' + cols[j].innerText + '"');
                }

                csv.push(row.join(','));
            }

            this._downloadCSV(csv.join('\n'), 'csvExport.csv');
        },

        _downloadCSV(csv, filename) {

            let csvFile;
            let downloadLink;

            // CSV file
            csvFile = new Blob([csv], { type: 'text/csv' });

            // Download link
            downloadLink = document.createElement('a');

            // File name
            downloadLink.download = filename;

            // Create a link to the file
            downloadLink.href = window.URL.createObjectURL(csvFile);

            // Hide download link
            downloadLink.style.display = 'none';

            // Add the link to DOM
            document.body.appendChild(downloadLink);

            // Click download link
            downloadLink.click();

            downloadLink.parentNode.removeChild(downloadLink);

        },

    },

};



// WEBPACK FOOTER //
// ./resources/assets/js/components/mixins/HtmlTableToCsvMixin.js